import { Check, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./PulmonologySection.css";

export default function PulmonologySection({ section, index, open, status, onMarkComplete, onToggle, children }) {
  const { t } = useTranslation("pulmonology");
  const { id, title } = section;

  return (
    <section className={`pulmo-section${open ? " is-open" : ""}`} id={`pulmo-${id}`}>
      <div className="pulmo-section__heading">
        <button type="button" className={`pulmo-section__status pulmo-section__status--${status}`} aria-label={t(status === "complete" ? "page.markIncomplete" : "page.markComplete", { title })} title={t(status === "complete" ? "page.markIncomplete" : "page.markComplete", { title })} onClick={() => onMarkComplete(id)}>
          {status === "complete" && <Check size={11} aria-hidden="true" />}
        </button>
        <button type="button" className="pulmo-section__toggle" aria-expanded={open} aria-controls={`pulmo-content-${id}`} onClick={onToggle}>
          <span className="pulmo-section__title">{title}</span>
          {status === "complete" && <span className="pulmo-complete">{t("page.complete")}</span>}
          <ChevronDown className="pulmo-section__chevron" size={14} aria-hidden="true" />
        </button>
        <div className="pulmo-section__actions">
          <button type="button" aria-label={t(open ? "page.collapse" : "page.expand", { title })} onClick={onToggle}>
            <ChevronDown size={13} aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="pulmo-section__content" id={`pulmo-content-${id}`} hidden={!open}>
        <div>{children}</div>
      </div>
      <span className="pulmo-section__number" aria-hidden="true">{index + 1}</span>
    </section>
  );
}
